import {
  GET_CHART_DATA_FAIL,
  GET_CHART_DATA_REQUEST,
  GET_CHART_DATA_SUCCESS,
  GET_CURRENT_DASHBOARD,
  GET_DASHBOARD_LIST_FAIL,
  GET_DASHBOARD_LIST_REQUEST,
  GET_DASHBOARD_LIST_SUCCESS,
  GET_DASHBOARD_WIDGET_LIST_FAIL,
  GET_DASHBOARD_WIDGET_LIST_REQUEST,
  GET_DASHBOARD_WIDGET_LIST_SUCCESS,
  GET_WIDGET_COORDINATES,
  GET_NEW_DASHBOARD_DATA_REQUEST,
  GET_NEW_DASHBOARD_DATA_SUCCESS,
  GET_NEW_DASHBOARD_DATA_FAIL,
  GET_CAMPAIGN_INSIGHTS_REQUEST,
  GET_CAMPAIGN_INSIGHTS_SUCCESS,
  GET_CAMPAIGN_INSIGHTS_FAIL,
  GET_ENGAGEMENT_DETAILS_REQUEST,
  GET_ENGAGEMENT_DETAILS_SUCCESS,
  GET_ENGAGEMENT_DETAILS_FAIL,
  GET_CAMPAIGN_DASHBOARD_REQUEST,
  GET_CAMPAIGN_DASHBOARD_SUCCESS,
  GET_CAMPAIGN_DASHBOARD_FAIL,
  GET_MEETING_LOGS_REQUEST,
  GET_MEETING_LOGS_SUCCESS,
  GET_MEETING_LOGS_FAIL,
} from "../constants/dashboardConstants";

export const dashboardReducer = (
  state = {
    loading: false,
    payload: {
      data: {
        data: [],
      },
    },
  },
  action,
) => {
  switch (action.type) {
    case GET_DASHBOARD_LIST_REQUEST:
      return { loading: true };
    case GET_DASHBOARD_LIST_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_DASHBOARD_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const dashboardWidgetsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DASHBOARD_WIDGET_LIST_REQUEST:
      return { loading: true };
    case GET_DASHBOARD_WIDGET_LIST_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_DASHBOARD_WIDGET_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const chartDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CHART_DATA_REQUEST:
      return { loading: true };
    case GET_CHART_DATA_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_CHART_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const widgetCoordinatesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_WIDGET_COORDINATES:
      return { active: true, payload: action.payload };
    default:
      return state;
  }
};

export const currentDashboardReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CURRENT_DASHBOARD:
      return { active: true, payload: action.payload };
    default:
      return state;
  }
};

export const newDashboardDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_NEW_DASHBOARD_DATA_REQUEST:
      return { loading: true };
    case GET_NEW_DASHBOARD_DATA_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_NEW_DASHBOARD_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const campaignInsightsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_INSIGHTS_REQUEST:
      return { loading: true };
    case GET_CAMPAIGN_INSIGHTS_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_CAMPAIGN_INSIGHTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const engagementDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ENGAGEMENT_DETAILS_REQUEST:
      return { loading: true };
    case GET_ENGAGEMENT_DETAILS_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_ENGAGEMENT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const campaignDashboardReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case GET_CAMPAIGN_DASHBOARD_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_CAMPAIGN_DASHBOARD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const meetingLogsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MEETING_LOGS_REQUEST:
      return { ...state, loading: true };
    case GET_MEETING_LOGS_SUCCESS:
      return { loading: false, payload: action.payload };
    case GET_MEETING_LOGS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
